import moment from 'moment';
import { EMARPOLDocuments, TMARPOLTank } from '../../marpol/@types';
import {
    ECRBRecordCode,
    ECRBRecordState,
    TCRBCommonData,
    TCRBCommonFields,
    ESubstanceCategories,
} from '../@types';
import { TCRBPlace } from '../@types';

export type TCRBItem29 = {
    placeOfBallast: TCRBPlace;
};

export type TCRBItem30 = {
    tanks: TCRBItem30Tank[];
};

export type TCRBItem30P1 = {
    totalQuantityDischarged: number;
};

export type TCRBItem30Tank = {
    selectedTank: TMARPOLTank;
    transferQuantity: number;
    newQuantity: number;
    substance: string;
    catgeory: ESubstanceCategories;
};

export type TCRBItem31 = {
    tanksPumpPipingSystemEmptied: boolean;
};

export type TCRBItem32 = {
    prewashCarriedOut: boolean;
};

export type TCRBItem33 = {
    dischargedAshoreAndEmptyTank: boolean;
};

export type TCRBItem34 = {
    exemptionGranted: boolean;
};

export type TCRBItem35 = {
    exemptionReason: string;
};

export type TCRBItem36 = {
    nameOfSurveyor: string;
};

export type TCRBItem37 = {
    surveyorOrganisation: string;
};

export type TCRBJ1 = TCRBCommonFields &
    TCRBCommonData & {
        id: string;
        recordCode: ECRBRecordCode.CRBJ;
        item29: TCRBItem29;
        item30: TCRBItem30;
        item30P1: TCRBItem30P1;
        item31: TCRBItem31;
        item32: TCRBItem32;
        item33: TCRBItem33;
        item34: TCRBItem34;
        item35: TCRBItem35;
        item36: TCRBItem36;
        item37: TCRBItem37;
    };

export type TCRBJ = TCRBJ1;

const CRBJ_DEFAULTS: {
    J: TCRBJ1;
} = {
    J: {
        id: '',
        _rev: '',
        marpolType: EMARPOLDocuments.CRB,
        state: ECRBRecordState.IDLE,
        selectedDate: moment().format('YYYY-MM-DD'),
        remarks: '',
        item29: {
            placeOfBallast: {
                place: 'IN_PORT',
                portName: '',
            },
        },
        item30: {
            tanks: [],
        },
        item30P1: {
            totalQuantityDischarged: 0,
        },
        item31: {
            tanksPumpPipingSystemEmptied: false,
        },
        item32: {
            prewashCarriedOut: false,
        },
        item33: {
            dischargedAshoreAndEmptyTank: false,
        },
        item34: {
            exemptionGranted: false,
        },
        item35: {
            exemptionReason: '',
        },
        item36: {
            nameOfSurveyor: '',
        },
        item37: {
            surveyorOrganisation: '',
        },
        recordCode: ECRBRecordCode.CRBJ,
    },
};

export { CRBJ_DEFAULTS };
